module.exports = __webpack_public_path__ + "static/media/ai.235b5725.png";